var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_428",
    "data-name": "Groupe 428",
    transform: "translate(-73.25 -277.75)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_2_background",
    "data-name": "2 background",
    width: 16,
    height: 16,
    transform: "translate(73.25 277.75)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_427",
    "data-name": "Groupe 427",
    transform: "translate(76.15 279.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Icon_\\u0421olor",
    "data-name": "\\uD83C\\uDFA8 Icon \\u0421olor",
    d: "M9,12H1.8A1.8,1.8,0,0,1,0,10.2V3A1.8,1.8,0,0,1,1.8,1.2h.6V.6A.6.6,0,1,1,3.6.6v.6H7.2V.6A.6.6,0,1,1,8.4.6v.6H9A1.8,1.8,0,0,1,10.8,3v7.2A1.8,1.8,0,0,1,9,12ZM1.2,6.6v3.6a.6.6,0,0,0,.6.6H9a.6.6,0,0,0,.6-.6V6.6Zm.6-4.2a.6.6,0,0,0-.6.6V5.4H9.6V3A.6.6,0,0,0,9,2.4H8.4V3A.6.6,0,1,1,7.2,3V2.4H3.6V3A.6.6,0,0,1,2.4,3V2.4ZM7.8,9H5.4a.6.6,0,1,1,0-1.2H7.8A.6.6,0,0,1,7.8,9ZM3,9a.6.6,0,1,1,.6-.6A.6.6,0,0,1,3,9Z",
    fill: "#C5A47E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendarIcon.383a8713d5f5da857b896462213b0d1d.svg";
export { ForwardRef as ReactComponent };